import WorkDetails from 'components/AddAgreementForm/WorkDetails/WorkDetails';

export default WorkDetails;
